import { useContext } from 'react';

import type { ModalContextType } from './ModalContext';
import { ModalContext } from './ModalContext';

export const useModalContext = () => {
  const context = useContext<ModalContextType | null>(ModalContext);
  return context;
};
